import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/hero/hero-shape-13.png'
import _imports_1 from '../../assets/images/hero/hero-shape-12.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7847903b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero-wrap style3 bg-squeeze" }
const _hoisted_2 = { class: "hero-slider-one" }
const _hoisted_3 = { class: "hero-slide-item" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row gx-5 align-items-center" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = {
  class: "hero-content",
  "data-speed": "0.10",
  "data-revert": "true"
}
const _hoisted_8 = { class: "titleH1" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "hero-btn" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "hero-img-wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image",
  class: "hero-shape-five bounce"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Image",
  class: "hero-shape-six moveHorizontal"
}, null, -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "popup-video"
}
const _hoisted_17 = { class: "d-table" }
const _hoisted_18 = { class: "d-table-cell" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "play-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", { src: "https://www.youtube.com/embed/bk7McNUjWgw" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_carousel, {
          autoplay: "10000",
          "wrap-around": true,
          transition: 800
        }, {
          addons: _withCtx(() => [
            _createVNode(_component_Pagination)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alaUnes, (alaUne, index) => {
              return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(alaUne.sousTitre), 1),
                            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.truncateText(alaUne.titre, 80)), 1),
                            _createElementVNode("p", {
                              innerHTML: alaUne.description
                            }, null, 8, _hoisted_9),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_router_link, {
                                to: {
                            name: 'ViewArticlePage',
                            params: { id: alaUne.id },
                          },
                                class: "btn style1 btn-decouvrir"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Découvrir ")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _hoisted_14,
                            _createElementVNode("img", {
                              src: _ctx.getUrlApiForFiles(alaUne?.urlImage),
                              alt: "Image",
                              class: "hero-img"
                            }, null, 8, _hoisted_15)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.isPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "popup-overlay-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPopupMethod(_ctx.isPopup)))
              }, _hoisted_21),
              _hoisted_22
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}